export const TAGS_INDUSTRIAL_COMERCIAL = [
  'Pe-direito',
  'Estrutura metalica',
  'Piso industrial',
  'Piso de alta resistencia',
  'Piso elevado',
  'Fachada de vidro',
  'Vitrine ampla',
  'Mezanino',
  'Docas',
  'Rampa de acesso',
  'Area de carga e descarga',
  'Area de descanso',
  'Patio de manobra',
  'Estacionamento privativo',
  'Estacionamento rotativo',
  'Estacionamento para caminhoes',
  'Portaria 24h',
  'Seguranca',
  'Monitoramento por cameras',
  'CFTV',
  'Sistema de combate a incendio',
  'Sprinklers',
  'Hidrantes',
  'AVCB atualizado',
  'Ar-condicionado central',
  'Forro modular',
  'Infraestrutura para TI',
  'Gerador de energia',
  'Energia trifasica',
  'Subestacao propria',
  'Poco artesiano',
  "Caixa d'agua",
  'Banheiro privativo',
  'Vestuario',
  'Refeitorio',
  'Copa',
  'Cozinha',
  'Espaco para estoque',
  'Escritorio administrativo',
  'Recepcao',
  'Auditorio',
  'Elevador',
  'Escada rolante',
  'Zoneamento',
  'Facil acesso a rodovias',
  'Proximo a portos',
  'Proximo a aeroportos',
  'Proximo a ferrovia',
  'Transporte publico proximo',
  'Regiao de alto fluxo',
  'Regiao de escritorios',
  'Regiao de comercio',
  'Regiao mista',
];

export const TAGS_IMOVEL = [
  'Sala de estar',
  'Sala de jantar',
  'Cozinha',
  'Quartos',
  'Suites',
  'Banheiro',
  'Lavabo',
  'Lavanderia',
  'Escritorio',
  'Corredor',
  'Hall de entrada',
  'Garagem',
  'Despensa',
  'Varanda',
  'Sacada',
  'Jardim',
  'Quarto de servico',
  'Sala de TV',
  'Home office',
  'Sala de jogos',
  'Sala de musica',
  'Atelier',
  'Sala de ginastica',
  'Estudio',
  'Sala de leitura',
  'Closet',
  'Deposito',
  'Sala de almoco',
  'Cantinho do cafe',
  'Solario',
  'Sotao',
  'Porao',
  'Comodo tecnico',
  'Sauna',
  'Piscina',
  'Churrasqueira',
  'Area gourmet',
  'Quintal',
];

export const TAGS_CONDOMINIO = [
  'Piscina adulto',
  'Piscina infantil',
  'Academia',
  'Sauna seca',
  'Sauna umida',
  'Salao de festas infantil',
  'Salao de festas adulto',
  'Churrasqueira',
  'Espaco gourmet',
  'Playground',
  'Quadra de tenis',
  'Quadra poliesportiva',
  'Campo de futebol',
  'Brinquedoteca',
  'Sala de jogos',
  'Sala de cinema',
  'Pet place',
  'Coworking',
  'Biblioteca',
  'Lounge',
  'Espaco para eventos',
  'Seguranca 24h',
  'Portaria',
  'Controle de acesso',
  'Sistema de cameras de seguranca',
  'Estacionamento',
  'Vagas para visitantes',
  'Area verde/jardins',
  'Bicicletario',
  'Pista de caminhada',
  'Horta comunitaria',
  'Deposito',
  'Elevadores',
  'Coleta seletiva de lixo',
  'Car Wash',
  'Wi-Fi nas areas comuns',
  'Sala de convencoes',
  'Mercado/loja de conveniencia',
  'Creche/bercario',
  'Banco eletronico',
  'Sala de reunioes',
  'Transporte coletivo',
  'Lavanderia coletiva',
  'Ofuro',
  'Hidromassagem',
  'Sala de massagem',
  'Espaco para meditacao',
  'Clube de tenis',
  'Academia de artes marciais',
  'Espaco para workshops e cursos',
  'Quiosques',
];

function removerDuplicadas(lista) {
  return Array.from(new Set(lista));
}

export function obterTagsPorTipoImovel(tipoImovel) {
  if (!tipoImovel) return [];

  if (tipoImovel === 'comercial' || tipoImovel === 'industrial') {
    return removerDuplicadas(TAGS_INDUSTRIAL_COMERCIAL);
  }

  if (tipoImovel === 'apartamento') {
    return removerDuplicadas([...TAGS_IMOVEL, ...TAGS_CONDOMINIO]);
  }

  return removerDuplicadas(TAGS_IMOVEL);
}
